import ConsentService, { ConsentCategory } from '@libs/focus-frontend-services/src/ConsentService';
import * as squatch from '@saasquatch/squatch-js';

window.triggerSaasquatch = () => {
  if (!ConsentService.isCategoryConsented(ConsentCategory.Necessary)) {
    return;
  }

  if (document.querySelector('.squatchembed') !== null) {
    squatch.ready(() => {
      squatch.init({
        tenantAlias: window.TLGLOBALS.SAASQUATCH_TENANT_KEY,
      });

      squatch.widgets().upsertUser({
        user: {
          id: window.TLGLOBALS.EMPLOYEEID,
          accountId: window.TLGLOBALS.ACCOUNTID,
          email: window.TLGLOBALS.EMAIL,
          firstName: window.TLGLOBALS.FIRST_NAME,
          lastName: window.TLGLOBALS.LAST_NAME,
          locale: window.TLGLOBALS.SAASQUATCH_LOCALE,
        },
        engagementMedium: 'EMBED',
        widgetType: 'REFERRER_WIDGET',
      });
    });
  }
};
